import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useLocation } from 'react-router-dom';
import { isPublicAuthPath } from '../../../utils/appPath';
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState<boolean>(false);
  const location = useLocation();

  const toggleSidebar = () => setShowSidebar((prev) => !prev);
  const isAuthPath = isPublicAuthPath(location.pathname);
  const hideHeader =
    isAuthPath ||
    location.pathname === "/admin/day-wise-card" ||
    location.pathname.includes("/live-attendance/");

  return (
    <div style={{ backgroundColor: "#f0f0f0", minHeight: "100vh" }}>
      {!isAuthPath && <Sidebar show={showSidebar} toggleSidebar={toggleSidebar} />}
      <div
        style={{
          marginLeft: isAuthPath ? 0 : showSidebar ? "190px" : "70px", 
          backgroundColor: "#f0f0f0",
          // transition: "margin-left 0.3s ease", 
        }}
      >
        {!hideHeader && <Header />}
        {children}
      </div>
    </div>
  );
};

export default Layout;
